import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_72033c6b-a282-4471-ad38-79d54845ec03/artifacts/4oq8gj7y_YADIMMO-logo%20-%20web.png";

export const TYPE_ICON_KEYS = {
  new_build: "new_build",
  renovation: "renovation",
  logistics: "logistics",
  business_premises: "business_premises",
};
